// extracted by mini-css-extract-plugin
export default {"searchFilter":"iT8UL"};